import { storage } from './util_05_storage';
var IMGCACHEKEY = 'LAZYLOADIMGS';
/**
 * 缓存，跟 webp 相关的
 * @memberof module:img
 * @param {string} src img的src
 * @param {boolean} usewebp 是否支持webp
 * @param {boolean} isSupported 是否被支持
 *
 */
// @TODO fix 放这个模块不合适

function imgHashCache(src, useWebP, isSupported) {
  var imgCache = storage.get(IMGCACHEKEY) || {};

  if (useWebP && isSupported) {
    var postfix = src.indexOf('?') !== -1 ? '&' : '?';
    src = "".concat(src).concat(postfix, "tp=webp");
  } // 缓存30天


  if (imgCache[src] && new Date().getTime() - imgCache[src] < 2592000 * 1000) {
    return src;
  }

  return false;
}

export { // eslint-disable-next-line import/prefer-default-export
imgHashCache };